<template>
  <div class="idfont" id="idfont">
    <div class="name">{{ name }}</div>
    <div class="gender">{{ gender ? (gender == 1 ? "男" : "女") : "" }}</div>
    <img class="head" :src="head_photo" />
    <div class="nation">{{ nation.replace(/族/g, "") }}</div>
    <div class="year" v-if="birthday">{{ birthday.substring(0, 4) }}</div>
    <div class="month" v-if="birthday">
      {{ parseInt(birthday.substring(5, 7)) }}
    </div>
    <div class="day" v-if="birthday">
      {{ parseInt(birthday.substring(8, 10)) }}
    </div>
    <div class="address">{{ address }}</div>
    <div class="no">{{ no }}</div>
  </div>
</template>

<script>
import domToImage from "dom-to-image";
export default {
  props: {
    //人像图片（base64）
    head_photo: {
      type: String,
      default: "",
    },
    //姓名
    name: {
      type: String,
      default: "",
    },
    //性别 男1女2
    gender: {
      type: [String, Number],
      default: "",
    },
    //民族
    nation: {
      type: String,
      default: "",
    },
    //生日 YYYY-MM-DD格式
    birthday: {
      type: String,
      default: "",
    },
    //地址
    address: {
      type: String,
      default: "",
    },
    no: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    getImage() {
      return new Promise((resolve, reject) => {
        domToImage
          .toPng(document.getElementById("idfont"))
          .then((dataUrl) => {
            resolve(dataUrl)
          })
          .catch((error) => {
            console.error("oops, something went wrong!", error);
            reject(error);
          });
        // html2Canvas(document.getElementById("idfont")).then((canvas) => {
        //   const jpeg = canvas.toDataURL("image/jpeg", 1.0);
        //   resolve(jpeg);
        // });
      });
    },
  },
};
</script>

<style scoped>
.idfont {
  width: 326px;
  height: 206px;
  background-position: center;
  background-repeat: no-repeat;
  /* background: url("~@/assets/image/id_f.bmp"); */
  position: relative;
  color: #333;
  /* font-weight: 600; */
}

.name {
  position: absolute;
  top: 16px;
  left: 65px;
  font-size: 14px;
}

.head {
  width: 102px;
  height: 126px;
  position: absolute;
  right: 20px;
  top: 26px;
  mix-blend-mode: multiply;
}

.gender {
  position: absolute;
  top: 40px;
  left: 65px;
  font-size: 12px;
}

.nation {
  position: absolute;
  top: 40px;
  left: 135px;
  font-size: 12px;
}

.year {
  position: absolute;
  top: 65px;
  left: 65px;
  font-size: 12px;
}

.month {
  position: absolute;
  top: 65px;
  left: 109px;
  font-size: 12px;
  width: 21px;
  text-align: center;
}

.day {
  position: absolute;
  top: 65px;
  left: 139px;
  font-size: 12px;
  width: 21px;
  text-align: center;
}

.address {
  position: absolute;
  top: 100px;
  left: 65px;
  font-size: 12px;
  width: 132px;
  line-height: 20px;
  text-align: left;
}

.no {
  position: absolute;
  bottom: 12px;
  left: 116px;
  font-size: 14px;
  text-align: left;
  letter-spacing: 1.4px;
}
</style>